module.exports = __webpack_public_path__ + "media/flags/vg-bdf80cd4.svg";